/**
 * @file IconNoRequired Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-no-required',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.75}"
  >
    <path
      fill="#757575"
      fill-rule="nonzero"
      d="M24 0C37.25483 0 48 10.74517 48 24 48 37.25483 37.25483 48 24 48 10.74517 48 0 37.25483 0 24 0 10.74517 10.74517 0 24 0ZM24 3C12.40202 3 3 12.40202 3 24 3 35.59798 12.40202 45 24 45 35.59798 45 45 35.59798 45 24 45 12.40202 35.59798 3 24 3ZM38.32355 15.36198C38.84425 15.88268 38.90211 16.69095 38.49712 17.27555L38.32355 17.4833 23.32355 32.4833C22.80285 33.004 21.99458 33.06185 21.40998 32.65686L21.20223 32.4833 12.5167 23.79777C11.93092 23.21198 11.93092 22.26223 12.5167 21.67645 13.0374 21.15575 13.84567 21.09789 14.43028 21.50288L14.63802 21.67645 22.263 29.301 36.20223 15.36198C36.78802 14.77619 37.73777 14.77619 38.32355 15.36198Z"
    />
  </g>
</svg>
`
);
